module.exports = __webpack_public_path__ + "img/x24.b6e6cd73.jpg";